module.exports = __webpack_public_path__ + "img/topLogo.63440792.png";